import _ from 'lodash'

const hasPermission = (sns, list, inHospital) => {
  if (_.isEmpty(sns)) {
    return false
  }
  sns = sns.replace(/\s+/g,"")
  let success = false
  var snList = sns.split('|')
  for (let i = 0; i < snList.length; i++) {
    if (snList[i].indexOf('&') < 0) {
      if (_.findIndex(list, {'sn': snList[i]}) >= 0) {
        success = true
        break
      }
      if (snList[i] === '_hasorg' && inHospital) {
        success = true
        break
      }
    } else {
      let snList2 = snList[i].split('&')
      let success2 = true
      for (let j = 0; j < snList2.length; j++) {
        if (_.findIndex(list, {'sn': snList2[j]}) >= 0) {
          continue
        }
        if (snList2[j] === '_hasorg' && inHospital) {
          continue
        }
        success2 = false
        break
      }
      success = success2
    }
  }
  return success
}

const hasPermissionRouter = (routers, list, inHospital) => {
  let result = _.cloneDeep(routers)
  if (_.isEmpty(routers)) {
    return result
  }
  function fn (rs) {
    if (_.isEmpty(rs)) {
      return
    }
    _.remove(rs, node => {
      if (_.isEmpty(node.permission) || hasPermission(node.permission, list, inHospital)) {
        return false
      }
      return true
    })
    if (_.isEmpty(rs)) {
      return
    }
    _.forEach(rs, node => {
      fn(node.children)
    })
  }
  fn(result)
  return result
}

export default {
  hasPermission,
  hasPermissionRouter
}
